module.exports = __webpack_public_path__ + "media/03d.ab304475.mp4";